/*
  import mixin object into a emotion.sh styled component with a spread operator

  Example:

  const AppHeaderHeader = styled.div({
    background: appHeaderBackground,
    ...verticalCenterText
  });
*/

export const noUserDragImage = {
  userDrag: 'none',
  userSelect: 'none'
};

export const noSelectText = {
  userSelect: 'none'
};

// create two images one at 2x resolution
//  import them then
//  use this like
//  ...hiResBgImage(loresImg, hiresImg, '100px', '200px');
export const hiResBgImage = (loresImg, hiresImg, width, height) => {
  const densePixelsQuery = {
    densePixels:
      '@media all and (-webkit-min-device-pixel-ratio: 1.5),' +
      'all and (min--moz-device-pixel-ratio: 1.5),' +
      'all and (min-device-pixel-ratio: 1.5)'
  };
  return {
    backgroundImage: 'url("' + loresImg + '")',
    backgroundSize: width + ' ' + height,
    [densePixelsQuery.densePixels]: {
      backgroundImage: 'url("' + hiresImg + '")'
    }
  };
};



// WEBPACK FOOTER //
// ./src/styles/mixins.js